export enum EFormFieldSize {
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum EFilterStrategy {
  EXACT = 'exact',
  INCLUSION = 'inclusion',
}

export enum ETextStyle {
  UPPER = 'upper',
  LOWER = 'lower',
  CAPITALIZE = 'capitalize',
  FIRST_LETTER = 'first-letter',
  INITIAL = 'initlial',
  NONE = 'none',
}

export enum EInputTypes {
    TEXT = 'text',
    NUMBER = 'number',
    EMAIL = 'email',
    TEL = 'tel'
}

export enum EButtonVariants {
    PRIMARY = 'primary',
    PRIMARY_GHOST = 'primary-ghost',
    SECONDARY = 'secondary',
    SECONDARY_GHOST = 'secondary-ghost',
    TERTIARY = 'tertiary',
    TERTIARY_GHOST = 'tertiary-ghost',
    PROCESS = 'process',
    ALTERNATIVE_1 = 'alternative-1',
    ALTERNATIVE_2 = 'alternative-2',
    ALTERNATIVE_3 = 'alternative-3',
    ALTERNATIVE_4 = 'alternative-4'
}
